import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuthToken } from "../TokenContext";
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import PropTypes from "prop-types";
import { Box, Typography, Chip } from '@mui/material';

const Dorametricsdashboard = ({ initialPodIds }) => {
  const [metricsData, setMetricsData] = useState(null);
  const token = useAuthToken();
  const { user } = useSelector(state => state.auth);

  useEffect(() => {
    const fetchDoraMetrics = async () => {
      if (user?.data?.[0]?.type === "stakeholder") {
        const payload = {};
      
        if (initialPodIds?.length > 0) {
          payload.pod_id = initialPodIds;
        } else if (user.data[0].client_code) {
          payload.org_code = user.data[0].client_code;
        }
    
        try {
          const response = await fetch(process.env.REACT_APP_STAKEHOLDER_JDORAMETRICSSTAKEHOLDER, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: token,
            },
            body: JSON.stringify(payload),
          });
    
          const data = await response.json();
         
          if (data?.body) {
            const parsedData = typeof data.body === 'string' ? JSON.parse(data.body) : data.body;
            setMetricsData(parsedData);
          }
        } catch (error) {
          console.error('Error fetching DORA metrics:', error);
        }
      } else {
        const headers = {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        };
        try {
          const response = await axios.post(
            process.env.REACT_APP_CLIENT_DORAMETRICSMANAGER, {
              "manager_id": user?.data?.[0]?.emp_id,
              "pod_id": initialPodIds,
            }, { headers: headers });
    
          const parsedData = typeof response.data.body === 'string' ? JSON.parse(response.data.body) : response.data.body;
          setMetricsData(parsedData);
        } catch (error) {
          console.error('Error fetching DORA metrics:', error);
        }
      }
    };

    if (token && user?.data?.[0]) {
      fetchDoraMetrics();
    }
  }, [token, user?.data?.[0]?.type, initialPodIds]);

  const getCategoryColor = (category) => {
    switch (category?.toLowerCase()) {
      case 'elite': return '#6200EA';
      case 'high': return '#2E7D32';
      case 'medium': return '#ED6C02';
      case 'low': return '#D32F2F';
      default: return '#757575';
    }
  };
  
  return (
    <Div>
      <CustomScrollbar>
        {metricsData && Array.isArray(metricsData) ? (
          metricsData.map((metric, index) => (
            <div 
              key={index} 
              style={{ 
                padding: "12px", 
                cursor: "pointer", 
                marginTop: "0.5rem", 
                backgroundColor: '#ffffff', 
                borderRadius: '10px', 
                width: '300px',
                borderLeft: `5px solid ${getCategoryColor(metric.Category)}`,
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                display: 'flex',
                flexDirection: 'column',
                gap: '4px'
              }} 
              className="metric-container"
              title={`Range: ${JSON.stringify(metric.Range || {})}`}
            >
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Typography variant="caption" sx={{ fontWeight: 600, color: '#666', textTransform: 'uppercase' }}>
                  {metric["Metric Name"]}
                </Typography>
                <Chip 
                  label={metric.Category} 
                  size="small" 
                  sx={{ 
                    height: '18px', 
                    fontSize: '10px', 
                    bgcolor: getCategoryColor(metric.Category),
                    color: '#fff',
                    fontWeight: 700
                  }} 
                />
              </Box>
              <Typography variant="h6" sx={{ color: '#333', fontWeight: 700, fontSize: '1.1rem' }}>
                {metric["Metric Value"]}
              </Typography>
            </div>
          ))
        ) : metricsData && typeof metricsData === 'object' ? (
          Object.entries(metricsData).map(([label, value], index) => (
            <div key={index} style={{ padding: "10px", cursor: "pointer", marginTop: "0.5rem", backgroundColor: '#EAEAEA', borderRadius: '8px', width: '300px' }} className="metric-container">
              <p className="metric-label" style={{ marginBottom: '0.5rem', color: '#333' }}>
                {label} - {parseFloat(value)}
              </p>
            </div>
          ))
        ) : null}
      </CustomScrollbar>
    </Div>
  );
};


Dorametricsdashboard.propTypes = {
  initialPodIds: PropTypes.array.isRequired,
};
const Div=styled.div`

display: flex;
flex-direction:column;
align-items: center;
margin: auto;
overflow:auto;

height: 6rem;
 @media screen and (min-width:320px) and (max-width:1080px){

  width:15rem;
  overflow:auto;
 }
`;
const CustomScrollbar = styled.div`
  height: 300px; /* Set the height of your container */
  width: 100%;   /* Set the width of your container */
  overflow: auto;

  /* Track */
  &::-webkit-scrollbar {
    width: 5px; /* You can adjust the width as needed */
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background-color: #888; /* Color of the scrollbar handle */
    border-radius: 5px;    /* Rounded corners of the handle */
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background-color: #555; /* Color of the handle on hover */
  }
`;
export default Dorametricsdashboard;
